import { useEffect, useState } from 'react';
import { Base } from 'components/Containers/BaseContainer';
import { ToolbarContainer } from 'components/Containers/ToolbarContainer';
import SWTab from 'components/Layout/Tabs/SWTab';
import { TabList, TabPanel, Tabs } from 'react-tabs';
import { PartsViewV2 } from './Parts/PartsViewV2';
import { PartsRecommendationView } from './Recommendation';
import { theme } from 'mui.theme';
import { SVG } from 'components/Asset/SVG';
import { AssetsViewV2 } from './Assets/AssetsViewV2';
import useAppTheme from 'hooks/useAppTheme';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const { svgIcons } = theme.palette;
/**
 * Renders a tabbed view for managing entities.
 *
 * Current tabs:
 * - Users
 * - Assets
 * - Operator
 */
export const CostAnalysisView = () => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  const [searchParams, setSearchParams] = useSearchParams();

  const normalizeTabIndex = (index: number) => {
    if (Number.isNaN(index)) return 0;
    return Math.min(Math.max(index, 0), 2);
  };

  const initialTabIndex = normalizeTabIndex(
    parseInt(searchParams.get('tab') ?? '0', 10)
  );

  const [tabIndex, setTabIndex] = useState(initialTabIndex);
  const [showBackButton, setShowBackButton] = useState(false);

  const updateSearchParam = (index: number) => {
    const normalizedIndex = normalizeTabIndex(index);
    setSearchParams({ tab: normalizedIndex.toString() }, { replace: true });
  };

  const switchToTab = (index: number) => {
    const normalizedIndex = normalizeTabIndex(index);
    setTabIndex(normalizedIndex);
    setShowBackButton(true);
    updateSearchParam(normalizedIndex);
  };

  // to track tab changes
  useEffect(() => {
    const urlTab = normalizeTabIndex(
      parseInt(searchParams.get('tab') ?? '0', 10)
    );
    if (urlTab !== tabIndex) {
      setTabIndex(urlTab);
    }
  }, [searchParams]);

  return (
    <Base enableDarkTheme={enableDarkTheme}>
      <Tabs
        selectedIndex={tabIndex}
        onSelect={(index) => {
          setShowBackButton(false);
          setTabIndex(index);
          updateSearchParam(index);
        }}
      >
        <TabList style={{ borderBottomColor: palette.primary }}>
          <ToolbarContainer
            style={{
              paddingBottom: 0,
            }}
            enableDarkTheme={enableDarkTheme}
          >
            {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}
            <SWTab enableDarkTheme={enableDarkTheme}>{t('assets')}</SWTab>
            <SWTab enableDarkTheme={enableDarkTheme}>{t('components')}</SWTab>
            {/* <SWTab enableDarkTheme={enableDarkTheme}>
              Maintenance Comparison
            </SWTab> */}
            <SWTab enableDarkTheme={enableDarkTheme}>
              {t('parts_recommendation')}
            </SWTab>
            {/* Email Icon */}
            <a href="mailto:sample@test.com" style={{ marginLeft: 'auto' }}>
              <SVG
                name="envelopeIcon"
                style={{
                  ...svgIcons?.primary,
                }}
              />
            </a>
          </ToolbarContainer>
        </TabList>

        {/* USER LIST VIEW CONTENT */}
        {/* BUG: The Permission tag causes MUI to detect the SWTab and create empty tab indexes */}

        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <AssetsViewV2
            showBackButton={showBackButton}
            setTabIndex={setTabIndex}
          />
        </TabPanel>

        {/* ASSET LIST VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <PartsViewV2
            showBackButton={showBackButton}
            setTabIndex={setTabIndex}
          />
        </TabPanel>

        {/* Operator LIST VIEW CONTENT */}
        {/* <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <MaintenanceComparisonView />
        </TabPanel> */}

        {/* Parts Recommendation VIEW CONTENT */}
        <TabPanel
          style={{
            padding: '11px 21px 21px',
          }}
        >
          <PartsRecommendationView
            enableDarkTheme={enableDarkTheme}
            showBackButton={showBackButton}
            setTabIndex={setTabIndex}
          />
        </TabPanel>
      </Tabs>
    </Base>
  );
};
